import { render, staticRenderFns } from "./DocumentEdit.vue?vue&type=template&id=4f2d958e&scoped=true&"
import script from "./DocumentEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocumentEdit.vue?vue&type=style&index=0&id=4f2d958e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d958e",
  null
  
)

export default component.exports